import { SiteUserRoleDto } from "../../../types/blastDtos";
import { isMockMode, postBlast, simulateDelay } from "../../api";

export interface CreateOrUpdateSiteUsersRequest {
	siteId: string;
	siteUsers: Array<SiteUserRoleDto>;
	isCreate?: boolean;
	isDelete?: boolean;
}

export const createOrUpdateSiteUsers = ({
	siteId,
	siteUsers,
	isCreate = true,
	isDelete = false,
}: CreateOrUpdateSiteUsersRequest) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`sites/updatePermissions`, {
		siteId,
		siteUsers,
	});
};
